import React, { useState } from 'react';
import { Section } from './Shared';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Es seguro compartir mi historia laboral?',
    a: 'Completamente. Cumplimos con la Ley 1581 de Habeas Data. Tu información se usa exclusivamente para el análisis actuarial y se maneja con protocolos de seguridad estrictos.'
  }, {
    q: '¿Necesito saber algo de pensiones para usar el servicio?',
    a: 'Absolutamente nada. Para eso existimos nosotros. Recibirás todo explicado en lenguaje claro, sin tecnicismos.'
  }, {
    q: '¿Cómo descargo mi historia laboral?',
    a: 'Es un proceso gratuito que toma menos de 5 minutos desde la página de Colpensiones o la app de tu fondo privado. Si necesitas ayuda, te guiamos paso a paso por WhatsApp.'
  }, {
    q: '¿La asesoría aplica para independientes y trabajadores por cuenta propia?',
    a: 'Sí. Tenemos un análisis especializado para independientes que incluye estrategias de optimización de IBC y aportes para maximizar la mesada futura.'
  }, {
    q: '¿Qué pasa si descubren semanas faltantes en mi historial?',
    a: 'Te entregamos el derecho de petición redactado y listo para radicar, junto con la guía de documentos necesarios para respaldar tu reclamación ante el fondo o Colpensiones.'
  }, {
    q: '¿Trabajan con personas en todo Colombia?',
    a: 'Sí. El servicio es 100% digital. Atendemos colombianos en cualquier ciudad del país y colombianos en el exterior que cotizan al sistema pensional colombiano.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section bg="slate" data-id="element-46">
      <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-47">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-48">
          Resolvemos tus dudas antes de que las tengas.
        </h2>
      </div>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-49">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <div key={index} className="bg-white border border-slate-200 rounded-xl overflow-hidden" data-id="element-50">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} data-id="element-51">
                <span className="font-semibold text-slate-900 pr-8" data-id="element-52">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-200 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-53" />
              </button>
              <AnimatePresence data-id="element-54">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-55">
                    <div className="px-6 pb-5 text-slate-600 border-t border-slate-100 pt-4" data-id="element-56">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </Section>;
}